<template>
    <main>
        <div class="dashbox w-100" v-if="link_list.customDashlet === undefined || link_list.customDashlet === false"
            :id="udid">
            <div class="dashbox-action tile-heading">
                <!-- <span class="ticket-info">
                    <a href="javascript:void(0)" data-bs-toggle="tooltip" data-bs-placement="bottom"
                        :title="link_list.note" >
                        <i class="fa-solid fa-exclamation"></i>
                    </a>
                </span>
                <span class="dashlet-refresh" @click="reFreshData()">
                    <i class="fa-solid fa-refresh"></i>
                </span> -->
                <span class="dashlet-closed" @click="updateStatus(udid,0)"><i class="fa-solid fa-xmark"></i></span>
            </div>
            <a href="javascript:void(0)" @click="handleLinkClick" class="custom-link">
                <div class="d-flex justify-content-center align-items-center mb-3" style="height:30px;">
                    <span class="number">{{ dataList.total }}</span>
                    <!-- <span class="icon"><i :class="link_list.iconClass"></i></span> -->
                </div>
                <h3 class="text-center">{{ link_list.title }}</h3>
            </a>
        </div>
        <div v-else :id="udid">
            <component :is="dynamicComponent"></component>
        </div>
    </main>
</template>
<script>
    import { ref } from "vue";
    import loader from "@/views/shared/loading/Loading.vue";

    export default {
        name: 'genericDashletCounter',
        props: {
            folder: {
                type: String,
                required: true
            },
            module: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: true
            },
            udid: {
                type: String,
                required: true
            },
            updateWidgetsList: '',
        },
        watch: {
            '$props': {
                handler: function (val) {
                    this.loadDashlet();
                },
                deep: true
            }
        },
        components: {
            loader,
        },
        data() {
            return {
                loading: false,
                dynamicComponent: null,
                dataList: {},
                search: {},
                link_list: {
                    routePath: '',
                    customDashlet: false,
                },
            }
        },
        async mounted() {
            await this.loadDashlet();
        },
        methods: {
            async loadDashlet() {
                const self = this;
                const modules = this.module;
                const folder = this.folder;
                const title = this.title;
                let searchaArray = require(`@/views/modules/${modules}/dashlets/${folder}/Counter.js`);
                self.link_list = searchaArray.default.link_list;
                if (typeof title !== 'undefined' && title !== '') {
                    self.link_list.title = title;
                }

                if (self.link_list.customDashlet === undefined || self.link_list.customDashlet === false) {
                    axios.get('api/modules/' + self.link_list.routePath + '/' + self.link_list.actionName,
                        {
                            params: {
                                page: self.link_list.page,
                                sort: self.link_list.sort,
                                search: self.link_list.search,
                                perPage: self.link_list.perPage
                            }
                        }).then(function (response) {
                            self.dataList = response.data;
                            self.loading = false;
                        }).catch(function (error) {
                            console.log('error');
                        })
                } else {
                    this.dynamicComponent = (await import(`@/views/modules/${modules}/dashlets/${folder}/custom/${self.link_list.customDashlet}.vue`)).default;
                }
            },
            updateStatus(id, status) {
                const self = this;
                $('#' + id).remove();
                self.customLoading = 'updatewidgets';
                axios.post('api/widgets/updatewidgetsstatus', { id: id, status: status }).then(function (response) {
                    self.customLoading = false;
                    var res = response.data;
                    self.updateWidgetsList();
                })
            },
            reFreshData() {
                const self = this;
                if (self.link_list.customDashlet === undefined || self.link_list.customDashlet === false) {
                    self.loadDashlet();
                } else {
                    self.$refs.childComponentRef.customLoadDashlet();
                }
            },
            handleLinkClick() {
                localStorage.removeItem('filters');

                const filtersToStore = this.link_list.search;
                console.log(filtersToStore);
                localStorage.setItem('filters', JSON.stringify(filtersToStore));
                
                this.$router.push(this.link_list.routePath);
            },
        },


    }
</script>